import { render, staticRenderFns } from "./UpdateStockSidebar.vue?vue&type=template&id=767e4c13&scoped=true&lang=pug&"
import script from "./UpdateStockSidebar.vue?vue&type=script&lang=js&"
export * from "./UpdateStockSidebar.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UpdateStockSidebar.vue?vue&type=style&index=1&id=767e4c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e4c13",
  null
  
)

export default component.exports